/**
 * Shortens a full name to the format "First Last I. M.".
 * @param full - The full name to be shortened.
 * @returns
 */
export const shortenName = (full: string) => {
  const parts = full.trim().split(/\s+/);
  if (parts.length === 0) return '';
  if (parts.length === 1) return parts[0];

  const initials = parts
    .slice(1)
    .map((p) => (p ? `${p.charAt(0)}.` : ''))
    .join(' ');

  return `${parts[0]} ${initials}`.trim();
};
